(() => {
  if (window.dtMapBound) return;
  window.dtMapBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dt-map-open]');
    if (!button) return;
    const container = button.closest('[data-dt-map]');
    if (!container || container.dataset.loaded) return;
    const source = container.dataset.src;
    if (!source || !source.startsWith('https://www.google.com/maps')) return;
    const iframe = document.createElement('iframe');
    iframe.title = 'Plan du centre DERMA, ' + container.dataset.address;
    iframe.src = source;
    iframe.referrerPolicy = 'no-referrer-when-downgrade';
    iframe.allowFullscreen = true;
    container.dataset.loaded = 'true';
    container.replaceChildren(iframe);
    iframe.focus();
  });
})();
